import Vue from 'vue';
import InputTrim from './InputTrim';
import ServerDialog from './ServerDialog';
import ServerQuery from './ServerQuery';
import antiAddictionBasisConfig from './antiAddiction/basisConfig';
import antiAddictionConfiguration from './antiAddiction/configuration';
import antiAddictionIdentified from './antiAddiction/identified';
import antiAddictionNoIdentified from './antiAddiction/noIdentified';
import aside from './aside';
import gameApiinfo from './game/apiinfo';
import header from './header';
import layout from './layout';
import pushPushContainer from './push/PushContainer';
import pushPushDeviceFilter from './push/PushDeviceFilter';
import pushPushNoticeSubscribe from './push/PushNoticeSubscribe';
import pushPushScheme from './push/PushScheme';
import pushPushTimes from './push/PushTimes';
import pushSelectUsers from './push/SelectUsers';
import rechargeDetail from './recharge/detail';
import sdkSearchDimension from './sdk/SearchDimension';
import sdkSetContentAllowed from './sdk/SetContentAllowed';
import sdkSetIdfaAllowed from './sdk/SetIdfaAllowed';
import sdkSetLoginAllowed from './sdk/SetLoginAllowed';
import sdkSetPageStyle from './sdk/SetPageStyle';
import sdkSetPay from './sdk/SetPay';
import sdkStyleDiyTitle from './sdk/style/DiyTitle';
import sdkUpload from './sdkUpload';
import server from './server';
import simpleSearchData from './simpleSearchData';
import systemList from './system/list';
import systemSearch from './system/search';
import watchFrame from './watch/frame';

Vue.component('sub-inputtrim',InputTrim);
Vue.component('sub-serverdialog',ServerDialog);
Vue.component('sub-serverquery',ServerQuery);
Vue.component('sub-antiaddiction-basisconfig',antiAddictionBasisConfig);
Vue.component('sub-antiaddiction-configuration',antiAddictionConfiguration);
Vue.component('sub-antiaddiction-identified',antiAddictionIdentified);
Vue.component('sub-antiaddiction-noidentified',antiAddictionNoIdentified);
Vue.component('sub-aside',aside);
Vue.component('sub-game-apiinfo',gameApiinfo);
Vue.component('sub-header',header);
Vue.component('layout',layout);
Vue.component('sub-push-pushcontainer',pushPushContainer);
Vue.component('sub-push-pushdevicefilter',pushPushDeviceFilter);
Vue.component('sub-push-pushnoticesubscribe',pushPushNoticeSubscribe);
Vue.component('sub-push-pushscheme',pushPushScheme);
Vue.component('sub-push-pushtimes',pushPushTimes);
Vue.component('sub-push-selectusers',pushSelectUsers);
Vue.component('sub-recharge-detail',rechargeDetail);
Vue.component('sub-sdk-searchdimension',sdkSearchDimension);
Vue.component('sub-sdk-setcontentallowed',sdkSetContentAllowed);
Vue.component('sub-sdk-setidfaallowed',sdkSetIdfaAllowed);
Vue.component('sub-sdk-setloginallowed',sdkSetLoginAllowed);
Vue.component('sub-sdk-setpagestyle',sdkSetPageStyle);
Vue.component('sub-sdk-setpay',sdkSetPay);
Vue.component('sub-sdk-style-diytitle',sdkStyleDiyTitle);
Vue.component('sub-sdkupload',sdkUpload);
Vue.component('sub-server',server);
Vue.component('sub-simplesearchdata',simpleSearchData);
Vue.component('sub-system-list',systemList);
Vue.component('sub-system-search',systemSearch);
Vue.component('sub-watch-frame',watchFrame);




// WEBPACK FOOTER //
// ./website/subComponents/autoload.js